<template>
  <el-dialog
    :visible="visible"
    :before-close="closeDialog"
    class="dialog pay-result-dialog"
    :close-on-click-modal="false"
    :close-on-press-escape="true"
  >
    <div class="pay-result">
      <template v-if="showSuccessTips">
        <img src="@/assets/images/pay-result-success.png" alt="" />

        <div class="text-success m-t-10">
          支付成功
        </div>
        <div class="m-t-10">
          <span class="text-success m-r-10">{{ successCloseCountDown }}</span>秒后关闭弹窗
        </div>
      </template>
      <template v-else>
        <img src="@/assets/images/pending-pay.png" alt="" />
        <div class="first m-t-10">等待您完成支付...</div>
        <div v-if="showErrorTips" class="text-danger m-t-10">
          支付失败，请前往支付中心完成支付
        </div>
        <div class="third m-t-10">
          如果您已在支付中心内完成支付，请点击下方“支付完成”按钮
        </div>

        <el-button
          class="m-t-20"
          type="primary"
          @click="confirmResult"
        >支付完成</el-button>
        <el-button
          v-if="showErrorTips"
          class="second-button"
          type="text"
          @click="goToPay"
        >
          <i class="el-icon-s-promotion icon"></i>
          前往支付中心
        </el-button>
      </template>
    </div>
  </el-dialog>
</template>

<script>
import { payResultDict } from '@/dictionary/financial'

export default {
  name: 'PayResultDialog',

  model: {
    prop: 'visible',
    event: 'change'
  },

  props: {
    visible: {
      type: Boolean,
      default: false
    },

    // 业务单号，用于业务平台查询支付结果
    orderCode: {
      type: String,
      default: ''
    },

    // 支付单号
    payNo: {
      type: [Number, String],
      default: ''
    },

    resultApi: {
      type: Function,
      required: true
    }
  },

  data() {
    return {
      showErrorTips: false,
      showSuccessTips: false,
      payResult: payResultDict.PENDING.value,
      timer: null,
      successCloseCountDown: 2
    }
  },

  methods: {
    // 确定支付结果
    confirmResult() {
      this.resultApi({
        orderCode: this.orderCode,
        payNo: this.payNo,
        payCode: this.payNo
      })
        .then(res => {
          this.payResult = Boolean(res.data)
          // 支付成功，关闭等待弹窗
          if (this.payResult === payResultDict.SUCCESS.value) {
            this.showSuccessTips = true
            this.closePageCountDown()
            this.timer = setTimeout(() => {
              this.closeDialog()
            }, this.successCloseCountDown * 1000)
          } else {
            this.showErrorTips = true
          }
        })
        .catch(err => {
          this.$message.error(err?.message || '查询支付结果失败，请稍后重试')
        })
    },

    closeDialog() {
      if (this.orderCode || this.payNo) {
        this.resultApi({
          orderCode: this.orderCode,
          payNo: this.payNo,
          payCode: this.payNo
        }).then(res => {
          this.payResult = Boolean(res.data)
          this.$emit('change', false)
          this.$emit('getResult', this.payResult)
          this.showErrorTips = false
          clearTimeout(this.timer)
        })
      } else {
        this.$emit('change', false)
        this.$emit('getResult', this.payResult)
        this.showErrorTips = false
        clearTimeout(this.timer)
      }
      this.successCloseCountDown = 2
    },

    goToPay() {
      this.$emit('toPayCenter')
    },

    // 关闭页面倒计时
    closePageCountDown() {
      const tempTimer = setInterval(() => {
        if (this.successCloseCountDown > 0 && this.successCloseCountDown <= 2) {
          this.successCloseCountDown--
        } else {
          this.closeDialog()
          clearInterval(tempTimer)
        }
      }, 1000)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/variable.scss';

.pay-result-dialog {
  ::v-deep .el-dialog {
    width: pixel-to-rem($n: 500);

    .el-dialog__headerbtn {
      background-color: $white-background-color;

      i {
        color: $third-text-color;
      }
    }
  }
  .pay-result {
    display: flex;
    flex-direction: column;
    align-items: center;

    img {
      width: pixel-to-rem($n: 120);
      height: pixel-to-rem($n: 120);
    }

    .first {
      font-size: pixel-to-rem($n: 20);
      @include text-bold;
    }

    .third {
      font-size: pixel-to-rem($n: 16);
      color: $third-text-color;
      text-align: center;
    }
  }
}

.second-button {
  ::v-deep &.el-button {
    margin: 0;
    color: $third-text-color;
    :hover {
      color: $primary-color;
    }
  }

  .icon {
    margin: 0 3px;
  }
}
</style>
